import '@grubersjoe/slide-menu/src/ts/SlideMenu';

$(() => {
    const menuElement = document.getElementById('mobile-menu');
    const SlideMenu = (window as any).SlideMenu;
    const menu = new SlideMenu(menuElement);
    const searchBar = $('[data-hide-search-bar-container]');
    const buttonHamburger = $('[data-slide-menu-trigger]');
    const buttonSearch = $('[data-slide-menu-close]');
    const menuMobileWrapper = $('[data-menu-display]');

    if (!menuElement) {
        return;
    }

    buttonHamburger.click(() => {
        menuMobileWrapper.addClass('is-active');
        menu.toggle();
        searchBar.removeClass('show');
        buttonHamburger.toggleClass('open');
    });

    buttonSearch.click(() => {
        menu.close();
        buttonHamburger.removeClass('open');
    });

    menuElement.addEventListener('sm.close-after', function () {
        menuMobileWrapper.removeClass('is-active');
    });    
});
